import { FunctionComponent } from "enzyme";
import { IconProps } from "./constants";

const IconIRAPending: FunctionComponent<IconProps> = ({
  width = "29",
  height = "23",
  className = "",
  name = "ira-pending",
}) => {
  return (
    <svg
      className={className}
      data-name={name}
      width={width}
      height={height}
      viewBox="0 0 29 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2H4C2.89543 2 2 2.83947 2 3.875V15.125C2 16.1605 2.89543 17 4 17H21C22.1046 17 23 16.1605 23 15.125V3.875C23 2.83947 22.1046 2 21 2Z"
        stroke="#305953"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 2H4C2.89543 2 2 2.83947 2 3.875V15.125C2 16.1605 2.89543 17 4 17H21C22.1046 17 23 16.1605 23 15.125V3.875C23 2.83947 22.1046 2 21 2Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12C13.8807 12 15 10.8807 15 9.5C15 8.11929 13.8807 7 12.5 7C11.1193 7 10 8.11929 10 9.5C10 10.8807 11.1193 12 12.5 12Z"
        stroke="#305953"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12C13.8807 12 15 10.8807 15 9.5C15 8.11929 13.8807 7 12.5 7C11.1193 7 10 8.11929 10 9.5C10 10.8807 11.1193 12 12.5 12Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 21H25C25.5304 21 26.0391 20.8068 26.4142 20.463C26.7893 20.1192 27 19.6529 27 19.1667V10"
        stroke="#305953"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 21H25C25.5304 21 26.0391 20.8068 26.4142 20.463C26.7893 20.1192 27 19.6529 27 19.1667V10"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconIRAPending;
